import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-italics-light",
  "use": "icon-italics-light-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-italics-light\">\n<path d=\"M7.4436 1.80176H13.6583\" stroke=\"#5587F0\" stroke-width=\"1.1651\" stroke-linecap=\"square\" />\n<path d=\"M4.33691 14.3213H10.5516\" stroke=\"#5587F0\" stroke-width=\"1.1651\" stroke-linecap=\"square\" />\n<path d=\"M10.9391 1.48438L7.05493 14.517\" stroke=\"#5587F0\" stroke-width=\"1.1651\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol